import React from 'react'
import "./style.scss"
import MainLayout from '../../layouts/mainLayout'
import LoginBtn from '../../components/buttons/loginBtn'
import { removeToken } from '../../functions/localStorage'
import { useNavigate } from 'react-router-dom'

const FinishQuiz = () => {

  const navigate = useNavigate()

  const logout = () => {
    removeToken();
    navigate("/login")
  }
  return (
    <MainLayout>

      <div className='finish__quiz__main'>
        <div className='finish__quiz__container'>
          <h1>
            Assessment Completed
          </h1>
          <p>
            Thank you for completing the FlexGrade Assessment. We value your insights and invite you to share your feedback at <a href='mailto:info@flexgrade.io'>info@flexgrade.io</a>. Our team will review your submission and follow up soon.
          </p>
          <div className='d-flex justify-content-center w-100'>
          <LoginBtn text={"Logout"} onClick={logout} />
          </div>
        </div>
      </div>

    </MainLayout>
  )
}

export default FinishQuiz